import React, { useState } from 'react';
import { Modal, Checkbox, App as AntdApp, message as antdMessage } from 'antd';

interface ConfirmModalOptions {
  title: string;
  content: string;
  onConfirm: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  okType?: 'primary' | 'danger';
  showCancel?: boolean;
}

interface InfoModalWithCheckboxOptions {
  title: string;
  content: string;
  onConfirm: () => void;
  onDontShowAgain?: (checked: boolean) => void;
  okText?: string;
}

let modalInstance: ReturnType<typeof AntdApp.useApp>['modal'] | null = null;
let messageInstance: ReturnType<typeof AntdApp.useApp>['message'] | null = null;

// Modal context 저장 함수
export const setModalInstance = (instance: ReturnType<typeof AntdApp.useApp>['modal']) => {
  modalInstance = instance;
};

// Message context 저장 함수
export const setMessageInstance = (instance: ReturnType<typeof AntdApp.useApp>['message']) => {
  messageInstance = instance;
};

// message 인스턴스 반환 (fallback 포함)
export const getMessage = () => {
  return messageInstance || antdMessage;
};

export const showConfirmModal = ({
  title,
  content,
  onConfirm,
  onCancel,
  okText = '확인',
  cancelText = '취소',
  okType = 'primary',
  showCancel = true,
}: ConfirmModalOptions) => {
  if (!modalInstance) {
    console.error('Modal instance not initialized');
    return;
  }

  modalInstance.confirm({
    title,
    content: <div style={{ whiteSpace: 'pre-line' }}>{content}</div>,
    okText,
    okType,
    cancelText,
    centered: true,
    onOk: onConfirm,
    onCancel: onCancel,
    cancelButtonProps: showCancel ? undefined : { style: { display: 'none' } },
    styles: {
      mask: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)'
      }
    }
  });
};

// "다시 보지 않기" 체크박스가 포함된 안내 모달
export const showInfoModalWithCheckbox = ({
  title,
  content,
  onConfirm,
  onDontShowAgain,
  okText = '확인',
}: InfoModalWithCheckboxOptions) => {
  if (!modalInstance) {
    console.error('Modal instance not initialized');
    return;
  }

  let dontShowAgain = false;

  modalInstance.confirm({
    title,
    content: (
      <div>
        <div style={{ whiteSpace: 'pre-line', marginBottom: '16px' }}>{content}</div>
        <Checkbox
          onChange={(e) => {
            dontShowAgain = e.target.checked;
          }}
        >
          다시 보지 않기
        </Checkbox>
      </div>
    ),
    okText,
    centered: true,
    cancelButtonProps: { style: { display: 'none' } },
    onOk: () => {
      if (onDontShowAgain) {
        onDontShowAgain(dontShowAgain);
      }
      onConfirm();
    },
    styles: {
      mask: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(10px)'
      }
    }
  });
};

// 삭제용 헬퍼 함수 (기존 코드와의 호환성을 위해)
export const showDeleteConfirm = ({
  itemCount,
  itemName = '콘텐츠',
  onConfirm,
  onCancel,
}: {
  itemCount: number;
  itemName?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  showConfirmModal({
    title: '알림',
    content: `삭제한 콘텐츠는 복구할 수 없습니다.\n삭제하시겠습니까?`,
    onConfirm,
    onCancel,
    okText: '확인',
    okType: 'danger',
  });
};